import { Typography } from 'antd'
import { AnnotationType } from 'types/building'

import AirConditionIcon from 'components/icons/AirConditionIcon'
import EquipmentIcon from 'components/icons/EquipmentIcon'
import HouseIcon from 'components/icons/HouseIcon'
import LightBulbIcon from 'components/icons/LightBulbIcon'

type Props = {
  type: AnnotationType | undefined
  alertId?: number
  onOpenAlertSetting?: () => void
  showAlertSetting?: boolean
}

export default function AnnotationHeader({
  type,
  alertId,
  onOpenAlertSetting,
  showAlertSetting
}: Props) {
  const annotationIcon = () => {
    switch (type) {
      case AnnotationType.ELECTRICITY:
        return <LightBulbIcon />
      case AnnotationType.AIR_CONDITION:
        return <AirConditionIcon />
      case AnnotationType.ARCHITECTURE:
        return <HouseIcon />
      case AnnotationType.EQUIPMENT:
        return <EquipmentIcon />
      default:
        return null
    }
  }

  const annotationText = () => {
    switch (type) {
      case AnnotationType.ELECTRICITY:
        return '電気'
      case AnnotationType.AIR_CONDITION:
        return '空調衛生'
      case AnnotationType.ARCHITECTURE:
        return '建築'
      case AnnotationType.MEMO:
        return 'メモ'
      case AnnotationType.EQUIPMENT:
        return '機材'
      default:
        return ''
    }
  }

  return (
    <div className="flex justify-between items-center pr-10">
      <div className="flex gap-[10px] ml-5 items-center">
        {type !== AnnotationType.MEMO ? (
          <div className="grid place-items-center w-9 h-9">
            {annotationIcon()}
          </div>
        ) : (
          annotationIcon()
        )}
        <Typography className="text-xl font-bold">
          {annotationText()}
        </Typography>
      </div>

      {showAlertSetting &&
        onOpenAlertSetting &&
        type !== AnnotationType.MEMO && (
          <div className="flex flex-col items-end gap-1">
            <span
              className={`text-[10px] leading-3 font-bold ${
                alertId ? 'text-[#3451D1]' : 'text-[#E73A3A]'
              }`}
            >
              {alertId ? '設定中' : '未設定'}
            </span>
            <div
              className="flex items-center justify-center border border-solid border-[#3451D1] text-[#3451D1] rounded cursor-pointer px-4 h-[30px] text-[12px] font-bold bg-white"
              onClick={onOpenAlertSetting}
            >
              アラート設定
            </div>
          </div>
        )}
    </div>
  )
}

AnnotationHeader.defaultProps = {
  alertId: undefined,
  onOpenAlertSetting: undefined,
  showAlertSetting: false
}
